import {Button, Col, Form, Popover, Row, Space, Spin, Table} from "antd";
import {
  ButtonExcel,
  ColumnPopoverDisplay,
  InputFields,
  ListActionButton,
  Notification,
} from "components/common";
import React, {useState, useEffect, useRef} from "react";
import {searchFields, serviceTable} from "./config";
import Icons from "assets/icons";
import "./Service.scss";
import {ExcelSVG, ListIconSVG} from "assets";
import AddNewModal from "./AddNewModal/AddNewModal";
import {technicalService} from "api";
import Icon from "@ant-design/icons/lib/components/Icon";
import {
  checkAdminQuanLy,
  exportFile,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";

const Service = () => {
  let savedTableOption = getTableOptions(
    "TECHNICAL_SERVICE_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? serviceTable.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          return {
            ...cl,
            show: true,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : serviceTable;
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter(e => e.show == true)
  );
  const [isAdmin, setIsAdmin] = useState(false);
  const [searchForm] = Form.useForm();
  const [loading, setLoading] = useState<any>(false);
  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [params, setParams] = useState<any>({});
  const aERef = useRef<any>();
  const handleAdd = async () => {
    aERef.current?.setData(null);
    aERef.current?.openModal();
  };

  // fetch
  const fetchListTechnicalService = async params => {
    try {
      setLoading(true);
      let response = await technicalService.searchListTechnicalService(params);
      setData(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const [dmTrangThai, setDmTrangThai] = useState<any>([]);
  const fetchDanhMucTrangThai = async () => {
    try {
      setLoading(true);
      let response = await technicalService.getDanhMucTrangThai();
      setDmTrangThai(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const [nhomDvkt, setNhomDvkt] = useState<any>([]);
  const fetchDanhMucNhomDVKT = async () => {
    try {
      setLoading(true);
      let response = await technicalService.getDanhMucNhomDVKT();
      setNhomDvkt(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const [loaiDvkt, setLoaiDvkt] = useState<any>([]);
  const fetchDanhMucLoaiDVKT = async () => {
    try {
      setLoading(true);
      let response = await technicalService.getDanhMucLoaiDVKT();
      setLoaiDvkt(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const [dmKhoa, setDmKhoa] = useState<any>([]);
  const fetchDanhMucKhoa = async params => {
    try {
      setLoading(true);
      let response = await technicalService.getDanhMucKhoa(params);
      setDmKhoa(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  useEffect(() => {
    const _isAdmin = checkAdminQuanLy();
    setIsAdmin(_isAdmin);
  }, []);
  //
  const onSave = async (values, type) => {
    try {
      if (type === 0) {
        let response = await technicalService.postTechnicalService({
          ...values,
        });
      } else if (type === 1) {
        let response = await technicalService.putTechnicalService({
          ...values,
        });
      }
      Notification(
        "success",
        type === 0 ? "Thêm thành công!" : "Sửa thành công!"
      );
      fetchListTechnicalService({
        ...params,
        page: page,
        limit: limit,
      });
    } catch (err) {}
  };
  //

  const onSearch = async values => {
    setParams({
      ...values,
    });
    fetchListTechnicalService({
      ...values,
      page: 1,
      limit: limit,
    });
  };
  const handleRow = async record => {
    editFunc(record);
  };
  const editFunc = async record => {
    aERef.current?.setData({...record});
    aERef.current?.openModal();
  };
  const deleteFunc = async record => {
    try {
      let response = await technicalService.delTechnicalService({
        id: record.id,
      });
      Notification("error", "Xoá thành công!");
      fetchListTechnicalService({
        ...params,
        page: page,
        limit: limit,
      });
    } catch (err) {}
  };

  const onPaginationChange = async (pg, pgSize) => {
    setPage(pg);
    setLimit(pgSize);
    fetchListTechnicalService({
      page: pg,
      limit: pgSize,
    });
  };

  const setShowColumns = showColumns => {
    saveTableOptions(
      "TECHNICAL_SERVICE_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  columns.map(it => {
    if (it.dataIndex === "action") {
      it.render = (v, r, i) => {
        return (
          <ListActionButton
            editFunction={isAdmin ? () => editFunc(r) : undefined}
            deleteFunction={isAdmin ? () => deleteFunc(r) : undefined}
          />
        );
      };
    }
  });
  useEffect(() => {
    fetchListTechnicalService({
      page: page,
      limit: limit,
    });
    fetchDanhMucNhomDVKT();
    fetchDanhMucLoaiDVKT();
    fetchDanhMucKhoa({
      page: 1,
      limit: 100,
    });
    fetchDanhMucTrangThai();
  }, []);
  useEffect(() => {}, [data, nhomDvkt, loaiDvkt, dmKhoa, dmTrangThai]);
  columns.map(it => {
    if (it.dataIndex === "idNhomDichVu")
      it.render = (v, r, i) =>
        nhomDvkt.find(it => it.id === v)?.tenNhomDichVu || "";
    if (it.dataIndex === "phanLoai")
      it.render = (v, r, i) =>
        loaiDvkt.find(it => it.id === v)?.tenLoaiDichVuKyThuat || "";
    if (it.dataIndex === "khoa")
      it.render = (v, r, i) =>
        dmKhoa.find(it => it.id === v)?.tenPhongBan || "";
    if (it.dataIndex === "trangThai")
      it.render = (v, r, i) =>
        dmTrangThai.find(it => it.id === v)?.tenTTDichVuKyThuat || "";
    if (it.dataIndex === "canTuVan" || it.dataIndex == "coBaoHiem") {
      it.render = (v, r, idx) =>
        v ? (
          <Row justify={"center"}>
            <Icon
              style={{color: "#45DC36"}}
              component={
                Icons.checkFilled as React.ForwardRefExoticComponent<any>
              }
            />
          </Row>
        ) : null;
    }
  });

  const getReportFile = async () => {
    const param = searchForm.getFieldsValue();
    if (!param) {
      Notification("warning", "Chưa chọn tên dịch vụ");
    } else {
      const nameFile = `Báo cáo dịch vụ kỹ thuật}`;
      exportFile("/qlkhambenh/dm-dich-vu/export-dm-dich-vu", param, nameFile);
    }
  };
  return (
    <Spin spinning={loading}>
      <div className="service">
        <div className="container">
          <Row>
            <Form form={searchForm} onFinish={onSearch}>
              <Space direction="vertical">
                <Row gutter={[8, 8]}>
                  <InputFields data={searchFields} />
                </Row>
                <Row justify={"end"} style={{gap: "4px"}}>
                  {isAdmin && (
                    <Button
                      type="primary"
                      icon={<Icons.add />}
                      onClick={handleAdd}
                    >
                      Thêm
                    </Button>
                  )}

                  <Button
                    type="primary"
                    icon={<Icons.search />}
                    htmlType="submit"
                  >
                    Tìm kiếm
                  </Button>
                </Row>
              </Space>
            </Form>
          </Row>
          <Row>
            <AddNewModal ref={aERef} onSave={onSave} />
          </Row>
        </div>

        <div className="container">
          <Space direction="vertical" style={{width: "100%"}}>
            <Row justify={"space-between"} gutter={[16, 16]}>
              <Col flex={"auto"}>
                <Row gutter={[16, 16]} style={{gap: 8}} justify={"end"}>
                  <ButtonExcel
                    icon={<ExcelSVG />}
                    className="custom-btn"
                    onClick={getReportFile}
                  >
                    Xuất báo cáo
                  </ButtonExcel>
                  <Popover
                    trigger="click"
                    placement="topLeft"
                    content={
                      <ColumnPopoverDisplay
                        setShowColumns={setShowColumns}
                        columns={defaultColumns}
                      ></ColumnPopoverDisplay>
                    }
                  >
                    <Button className="btn-sub" icon={<ListIconSVG />}>
                      Cột hiển thị
                    </Button>
                  </Popover>
                </Row>
              </Col>
            </Row>
            <CustomResizableTable
              setShowColumns={setShowColumns}
              rowKey={record => record.id}
              bordered
              dataSource={data}
              loading={loading}
              // pagination={{
              //   total: data?.total,
              //   pageSize: data?.limit,
              //   current: data?.page,
              //   onChange: onPaginationChange,
              //   showSizeChanger: true,
              // }}
              onRow={record => ({
                onDoubleClick: () => handleRow(record),
              })}
              columns={columns}
              rowSelection={{
                type: "checkbox",
              }}
              scroll={{x: 1400}}
            />
          </Space>
        </div>
      </div>
    </Spin>
  );
};

export default Service;
